const GA4_MEASUREMENT_ID = 'G-9RDW3MNM51';

const normalizeCurrency = (currency) => {
  if (!currency) return undefined;
  const value = String(currency).toUpperCase();
  return value === 'TL' ? 'TRY' : value;
};

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;

  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

  window.gtag('event', name, { ...clean, send_to: GA4_MEASUREMENT_ID });
  return true;
}

export function trackSignUp({ method = 'email', country } = {}) {
  return trackEvent('sign_up', {
    method,
    country: country || undefined,
  });
}

export function trackBeginCheckout({ provider, plan, amount, currency, sessionId } = {}) {
  const normalizedCurrency = normalizeCurrency(currency);
  return trackEvent('begin_checkout', {
    value: Number(amount || 0),
    currency: normalizedCurrency,
    payment_provider: provider,
    checkout_session: sessionId,
    items: [{
      item_id: plan || 'pro',
      item_name: 'PaydaAI Pro',
      item_category: 'subscription',
      quantity: 1,
      price: Number(amount || 0),
    }],
  });
}

export function trackPurchase({ sessionId, provider, plan, amount, currency } = {}) {
  if (!sessionId || typeof window === 'undefined') return false;

  const dedupeKey = `paydaai_purchase_event_${sessionId}`;
  try {
    if (window.localStorage.getItem(dedupeKey) === '1') return false;
  } catch {
    // Analytics must never block the payment flow.
  }

  const normalizedCurrency = normalizeCurrency(currency);
  const sent = trackEvent('purchase', {
    transaction_id: sessionId,
    value: Number(amount || 0),
    currency: normalizedCurrency,
    payment_provider: provider,
    items: [{
      item_id: plan || 'pro',
      item_name: 'PaydaAI Pro',
      item_category: 'subscription',
      quantity: 1,
      price: Number(amount || 0),
    }],
  });

  if (sent) {
    try { window.localStorage.setItem(dedupeKey, '1'); } catch { /* noop */ }
  }
  return sent;
}

export function trackFirstQuoteCreated({ quoteId, language, currency, mode, itemCount } = {}) {
  if (!quoteId || typeof window === 'undefined') return false;

  const dedupeKey = `paydaai_first_quote_event_${quoteId}`;
  try {
    if (window.localStorage.getItem(dedupeKey) === '1') return false;
  } catch {
    // Analytics must never block quote creation.
  }

  const sent = trackEvent('first_quote_created', {
    quote_language: language,
    currency: normalizeCurrency(currency),
    quote_mode: mode,
    item_count: Number(itemCount || 0),
  });

  if (sent) {
    try { window.localStorage.setItem(dedupeKey, '1'); } catch { /* noop */ }
  }
  return sent;
}
